import script from "./UListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./UListItem.vue?vue&type=script&setup=true&lang=ts"

import "./UListItem.vue?vue&type=style&index=0&id=48ddf23e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ddf23e"]])

export default __exports__